import { render } from "./taskDetail.vue?vue&type=template&id=52804ed2&scoped=true"
import script from "./taskDetail.vue?vue&type=script&lang=js"
export * from "./taskDetail.vue?vue&type=script&lang=js"

import "./taskDetail.vue?vue&type=style&index=0&id=52804ed2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52804ed2"]])

export default __exports__